import {
  ReviewBreakpointConfig as IReviewBreakpointConfig,
  ReviewsListConfig as IReviewsListConfig
} from 'services/api-service'

type JsonLdIdSourceType = 'CANONICAL' | 'CUSTOM' | 'LOCATION_HREF'
type RelatedReviewsDisplayType = 'NONE' | 'INCLUDED' | 'SEPARATE'

export enum RelatedReviewsDisplayTypes {
  NONE = 'NONE',
  INCLUDED = 'INCLUDED',
  SEPARATE = 'SEPARATE'
}

export class ReviewsListConfig implements IReviewsListConfig {
  constructor(config: IReviewsListConfig) {
    this.breakpoints = config.breakpoints
    this.defaultSortOption = config.defaultSortOption
    this.displayUserToolbar = config.displayUserToolbar
    this.enableFrontEndReviewTranslation = config.enableFrontEndReviewTranslation
    this.enableLazyLoading = config.enableLazyLoading
    this.headingLevel = config.headingLevel || 2
    this.hideWriteReview = config.hideWriteReview
    this.initialPageSize = config.initialPageSize
    this.jsonLdIdSource = config.jsonLdIdSource
    this.pageSize = config.pageSize
    this.relatedReviewsDisplay = config.relatedReviewsDisplay
    this.relatedInitialPageSize = config.relatedInitialPageSize
    this.relatedPageSize = config.relatedPageSize
    this.showPurchaserBadge = config.showPurchaserBadge
    this.sortOptions = config.sortOptions
    this.toggleFiltersDesktop = config.toggleFiltersDesktop
    this.toggleFiltersMobile = config.toggleFiltersMobile
    this.useShowMore = config.useShowMore
    this.widgetDivId = config.widgetDivId
  }

  breakpoints: Array<IReviewBreakpointConfig>
  defaultSortOption: string
  displayUserToolbar: boolean
  enableFrontEndReviewTranslation: boolean
  enableLazyLoading: boolean
  headingLevel: number
  hideWriteReview: boolean
  initialPageSize: number
  jsonLdIdSource?: JsonLdIdSourceType
  pageSize: number
  relatedReviewsDisplay: RelatedReviewsDisplayType
  relatedInitialPageSize: number
  relatedPageSize: number
  showPurchaserBadge: boolean
  sortOptions: string[]
  toggleFiltersDesktop: boolean
  toggleFiltersMobile: boolean
  useShowMore: boolean
  widgetDivId: string
}

let defaultConfig: IReviewsListConfig = {}
export function loadConfig(config: IReviewsListConfig): void {
  defaultConfig = new ReviewsListConfig(config)
}

export { defaultConfig as default }
